import styled from "styled-components";

export const SMaintenanceWarningModalIcon = styled.div`
  padding: 18.75px;
  border-radius: 50%;
  border: 0.787px solid #e8eff3;
  background: #b4c9d7;
  color: var(--ui-background);
`;
